import { getOfficeNewByFirm } from "../../../Services/Office";
import { getFirmContactByFirmId } from "../../../Services/FirmContact";
import { getDataAdminByFirmId } from "../../../Services/DataAdmin";
import { getOfficeMainContactsByFirmId } from "../../../Services/OfficeMainContact";
import { isProfessionalsMainContactEnabled } from "../../../Enums/LegacyRedirection";
import type { ProfessionalsLoaderData } from "./Professionals";

export async function fetchProfessionalsCatalogs(
  id: string,
): Promise<ProfessionalsLoaderData> {
  const offices = await getOfficeNewByFirm(id);
  const includeMainContacts = isProfessionalsMainContactEnabled();
  const [dataAdmin, firmContact, officeMainContacts] = await Promise.all([
    getDataAdminByFirmId(id),
    getFirmContactByFirmId(id),
    includeMainContacts ? getOfficeMainContactsByFirmId(id) : Promise.resolve([]),
  ]);

  return {
    offices,
    dataAdmin: Array.isArray(dataAdmin) ? dataAdmin : [],
    firmContact,
    officeMainContacts,
  };
}
